export interface IPDPStickers {
  stickers: IPDPStickersItem[];
}

export interface IPDPStickersItem {
  position: PdpStickerPosition;
  id: number;
  content: string;
  contentType: PdpStickerContenType;
}

export enum PdpStickerPosition {
  NotVisible = 'NotVisible',
  DetailsSectionBottom = 'DetailsSectionBottom',
  DescriptionLeft = 'DescriptionLeft',
  DetailsSection = 'DetailsSection',
  DescriptionRight = 'DescriptionRight',
}

export enum PdpStickerContenType {
  Html = 'HTML',
  ImageUrl = 'ImageUrl',
}
